export type ContentType = "movie" | "tv" | "news" | "special";

export interface SpecialArticle {
  id: string;
  title: string;
  summary: string;
}

export interface ContentItem {
  id: string;
  type: ContentType;
  title: string;
  image: string;
  cover: string;
  rating?: number;
  year: string;
  releaseDate: string;
  region: string;
  genres: string[];
  cast: string;
  director: string;
  duration?: string;
  episodes?: number;
  seasons?: number;
  status?: string;
  summary: string;
  content: string[];
  tags: string[];
  articles?: SpecialArticle[];
}

export interface HeroSlide {
  id: string;
  title: string;
  tagline: string;
  image: string;
  targetId: string;
}

export const TYPE_LABEL: Record<ContentType, string> = {
  movie: "电影",
  tv: "电视剧",
  news: "资讯",
  special: "专题",
};